<script setup lang="ts">
const { $fetchApi }: any = useNuxtApp();
const router = useRouter();
const blogs = reactive<any>([]);

const getBlog = async () => {
  try {
    const { status, data } = await $fetchApi("/cms/blog/get");
    if (status) Object.assign(blogs, data.data);
  } catch (error) {
    console.error("Error fetching landing blog:", error);
  }
};

const toBlogDetail = (item: any) => {
  router.push(`/blog/${item.slug}`);
};

await getBlog();
</script>

<template>
  <div class="container py-12">
    <div class="flex flex-col items-center mb-8">
      <h2 class="text-base">Our Blog</h2>
      <p class="text-3xl font-medium my-2">
        Ride Smart, Explore Bali – Tips & Stories for Your Journey
      </p>
    </div>

    <ClientOnly>
      <Swiper
        :modules="[SwiperA11y, SwiperAutoplay, SwiperPagination]"
        :slides-per-view="3"
        :loop="true"
        :space-between="20"
        :breakpoints="{
          0: {
            slidesPerView: 1.2,
          },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
        }"
        :pagination="{
          clickable: true,
        }"
      >
        <SwiperSlide v-for="(item, i) in blogs">
          <div
            class="rounded-2xl bg-white max-h-min flex flex-col items-center shadow-lg"
          >
            <NuxtImg
              preset="thumb"
              :src="item.images"
              :alt="item?.title"
              class="w-full h-[32vh] object-cover rounded-t-2xl bg-slate-100"
            />

            <div class="px-4 pt-8">
              <div class="font-bold !text-xl line-clamp-2 text-ellipsis h-14">
                {{ item.title }}
              </div>
              <div
                class="mb-4 mt-2 text-ellipsis line-clamp-3 !h-[75px] !overflow-hidden text-gray-500"
              >
                <span v-html="item.description.slice(0, 200)" />
              </div>
              <div>
                <MazBtn
                  color="white"
                  class="!p-0 hover:!bg-transparent hover:!text-primary"
                  @click="() => toBlogDetail(item)"
                >
                  Read More
                  <Icon name="mdi:arrow-right" />
                </MazBtn>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </ClientOnly>

    <div class="text-center mt-4">
      <MazBtn
        color="primary"
        class="mt-4 mb-8"
        @click="() => router.push('/blog')"
      >
        View All Articles
        <Icon name="mdi:chevron-right" />
      </MazBtn>
    </div>
  </div>
</template>
